import {Component, Input, OnInit} from '@angular/core';
import {IonCol, IonRow} from '@ionic/angular/standalone';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
    selector: 'app-error-detail-rule',
    standalone: true,
    imports: [IonRow, IonCol, TranslatePipe],
    templateUrl: './error-detail-rule.component.html',
    styleUrls: ['./error-detail-rule.component.scss'],
})
export class ErrorDetailRuleComponent implements OnInit {
    @Input({required: true}) ruleNameKey!: string;
    @Input() content?: string;

    constructor() {
    }

    ngOnInit() {
    }

}
